export default function getHeaderOffset() {
  const header = document.querySelector('.header');

  if (!header) {
    return 0;
  }

  const headerStyles = getComputedStyle(header);

  if (header && headerStyles.position === 'fixed') {
    return header.offsetHeight;
  }

  return 0;
}
